// axios nao pega a autorizacao, nao dá para usar 
// estudar se for o caso

import axios from "axios"
import Baseurlaxios from "../../../services/baseurlaxios"

import BaseurlApi from "../../../services/baseurlapi"

import { toastr } from "react-redux-toastr"
import api from "../../../services/api"

export function getData(codigoPuxada) {

    return (dispatch) => {

        axios.get(`${BaseurlApi}/GetPrice?codigoPuxada=${codigoPuxada}`, {
            //withCredentials: true,
            // auth: {
            //     username: 'usuario',
            //     password: 'password'
            // },

            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_Price",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro priceActions getData: " + error)
            })
    };
}

export function enviaPriceRegistros(arrayprice_CodCatite,arrayprice_conditionId, codpuxada, usuario) {

    return (dispatch) => {
        api.post(`/Tb_Log_Envio_price/IncluiLogPrice?CodPuxada=${codpuxada}&Usuario=${usuario}`, {
            "ArraycodCatite": arrayprice_CodCatite
           , "ArrayconditionId": arrayprice_conditionId
        }
        )
            .then(response => {
                dispatch([
                    getData(0)
                ])
                dispatch([
                    getData(codpuxada)
                ])
            })
            .catch(error => {
                toastr.error("Erro priceActions enviaRegistros: " + error.statusText)
            })
    }
}

export function getDataTdsRevendas() {
    return (dispatch) => {
        axios.get(`${Baseurlaxios}/Tb_Dist/TodosDist`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
            .then(response => {
                dispatch({
                    type: "GET_DATA_LSTRVD",
                    payload: response
                })
            })
            .catch(error => {
                toastr.error("Erro priceActions getDataTdsRevendas: " + error)
            })
    };
}